import React, { FC } from 'react';
import styled from 'styled-components';

import BasicText from '@ui/atoms/BasicText';

import theme from '@theme/FolxTheme';

export interface IFlowFooterContent {
	loggedIn: {
		text: string;
		cta: string;
	};
	loggedOut: {
		text: string;
		cta: string;
	};
}

export interface IFlowFooterProps {
	footerContent?: IFlowFooterContent;
	stepKey?: string;
}

const defaultContent = {
	loggedIn: {
		text: 'Questions? Check out the',
		cta: 'Message Center',
	},
	loggedOut: {
		text: 'Already a member? ',
		cta: 'Login',
	},
};

const Footer = styled.footer`
	display: flex;
	justify-content: center;
	min-width: 100%;
	background-color: ${theme.colors.lightGray};
	padding-top: ${theme.spacing.lg};
	padding-bottom: ${theme.spacing.lg};
	text-align: center;
`;

const DefaultText = ({ text, cta }: { text: string; cta: string }) => {
	return (
		<BasicText variant="footer">
			{text} <a href="https://support.folxhealth.com/hc/en-us">{cta}</a>
		</BasicText>
	);
};

const LoginText = ({ text, cta }: { text: string; cta: string }) => {
	return (
		<BasicText variant="footer">
			{text} <a href={`${process.env.GATSBY_WEBAPP_ROOT}/app/sign_in/`}>{cta}</a>
		</BasicText>
	);
};

const FlowFooter: FC<IFlowFooterProps> = ({ stepKey, footerContent = defaultContent }) => {
	return (
		<Footer>
			{stepKey === 'ELIGIBILITY' ? (
				<LoginText {...footerContent.loggedOut} />
			) : (
				<DefaultText {...footerContent.loggedIn} />
			)}
		</Footer>
	);
};
export default FlowFooter;
